export type Service = {
  id: string
  name: string
  blurb: string
  bullets: string[]
  startingAt: string
  image: string
  isNew?: boolean
}

export const services: Service[] = [
  {
    id: 'windows',
    name: 'Window Cleaning',
    blurb:
      'Streak-free glass inside and out, with screens and sills wiped down before we leave.',
    bullets: ['Interior + exterior glass', 'Screens & tracks', 'Hard water spot removal'],
    startingAt: 'from $149',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/da8276a1-5642-40c1-a133-d357a8ac3222.jpg'
  },
  {
    id: 'gutters',
    name: 'Gutter Cleaning',
    blurb:
      'Hand-cleared gutters and downspouts so Nebraska storms drain away from your foundation.',
    bullets: ['Debris hauled away', 'Downspout flush', 'Photo proof when finished'],
    startingAt: 'from $129',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/6d7d6b89-ce6d-4eec-95de-3fab6c4a9ef1.jpg'
  },
  {
    id: 'pressure-washing',
    name: 'Pressure Washing',
    blurb:
      'Driveways, sidewalks, patios and siding brought back to their original color — safely.',
    bullets: ['Concrete & pavers', 'Soft wash for siding', 'Decks & fences'],
    startingAt: 'from $199',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/4b51f4d1-d697-4fc7-a361-e4bb8a91781f.jpg',
    isNew: true
  }
]

export const testimonials = [
  {
    name: 'Jenna R.',
    location: 'South Lincoln',
    quote:
      'Mason texted when he was on the way, showed up right on time, and our windows have never looked this clear. Easiest home service call I have made all year.',
    service: 'Window Cleaning'
  },
  {
    name: 'Dave K.',
    location: 'Waverly',
    quote:
      'Our driveway looked 20 years old. He pressure washed it in an afternoon and it looks brand new. Fair price and he cleaned up after himself.',
    service: 'Pressure Washing'
  },
  {
    name: 'Marta L.',
    location: 'Near South',
    quote:
      'Gutters were packed with maple seeds. He sent before-and-after photos of every corner of the roofline. Very thorough young man.',
    service: 'Gutter Cleaning'
  }
]

export const faqs = [
  {
    q: 'How fast can I get an estimate?',
    a: 'Most estimates go out the same day. Call or text 402-417-0003 with your address and what you need cleaned, and Mason will get you a firm price — free, with no pressure.'
  },
  {
    q: 'Do I need to be home?',
    a: 'Only for interior window cleaning. For exterior windows, gutters, and pressure washing you can be at work — we will send photos when the job is done.'
  },
  {
    q: 'Is pressure washing safe for my siding?',
    a: 'Yes. We soft wash siding at low pressure with the right detergents, and save high pressure for concrete and hard surfaces only.'
  },
  {
    q: 'Are you insured?',
    a: 'Bucket Hat Cleaning LLC is a fully licensed and insured Nebraska business. Certificate of insurance available on request.'
  },
  {
    q: 'What does it cost?',
    a: 'Pricing depends on the size of your home and how much buildup there is. Window cleaning typically starts around $149, gutters around $129, and pressure washing around $199. Every quote is flat-rate and given up front.'
  }
]
